import { isFeatureEnabled } from '@services/FeatureConfigService'

export function isFeatureEnabledListener (message) {
    return isFeatureEnabled(message.data.feature, message.data.defaultValue)
}
